<template>
  <b-overlay :show="isLoading" z-index="9999" fixed rounded="lg">
    <horizontal-stepper
      class="bg-transparent shadow-none"
      :steps="signUpSteps"
      :keep-alive="false"
      @completed-step="completeStep"
      @active-step="isStepActive"
      @stepper-finished="signUp"
    />

    <template #overlay>
      <AppSpinner class="text-secondary mx-auto" size="8"/>
    </template>
  </b-overlay>
</template>

<script>
  import {signUp} from "../../api/user.api";
  import HorizontalStepper from 'vue-stepper';
  import StepOne from "./StepOne";
  import StepTwo from "./StepTwo";
  import StepThree from "./StepThree";
  import AppSpinner from "../../components/common/utils/AppSpinner";

  export default {
    name: "SignUpForm",
    components: {AppSpinner, HorizontalStepper},
    data() {
      return {
        isLoading: false,
        tokenDecoded: null,

        signUpSteps: [
          {
            icon: 'person',
            name: 'first',
            title: this.$t(this.$getConst.pages.sign_up.sign_up_details),
            component: StepOne,
            completed: false

          },

          {
            icon: 'lock',
            name: 'third',
            title: this.$t(this.$getConst.pages.sign_up.sign_up_security),
            component: StepThree,
            completed: false
          }
        ]
      }
    },
    methods: {
      // Executed when @completed-step event is triggered
      completeStep(payload) {
        this.signUpSteps.forEach((step) => {
          if (step.name === payload.name) {
            step.completed = true;
          }
        })
      },
      // Executed when @active-step event is triggered
      isStepActive(payload) {
        this.signUpSteps.forEach((step) => {
          if ((step.name === payload.name)&&(step.completed === true)) {
              step.completed = false;
          }
        })
      },
      // Executed when @stepper-finished event is triggered
      signUp() {
        this.isLoading = true;
        signUp(this.$store.getters["signup/userData"], this.$route.query.token_hint).then(
          () => {
            this.$snotify.success(
              this.$t(this.$getConst.pages.alerts.redirecting_to_login_page),
              this.$t(this.$getConst.pages.sign_up.sign_up_completed_message)
            );
            let self = this;
            setTimeout(
              function () {
                self.$store.dispatch("auth/logout");
                self.isLoading = false;
              },
              5000
            );
          },
          (error) => {
            this.handleApiError(error);
            this.isLoading = false;
          }
        )
      }
    },
  }
</script>

<style scoped>
  @import '../../assets/css/vue-phone-number-input.css';
</style>
